module.exports = __webpack_public_path__ + "img/number.0a416e47.png";